import { createReduxAsyncThunk } from 'shared/utils';

import { stationsAPI } from 'entities/stations';

import { STATIONS_STATE } from '../../constants';

import { StationsState } from '../../types';

export const getStationsPriceReportTimeSlots = createReduxAsyncThunk<
  StationsState['stationsPricesReportTimeSlots']['data']
>(
  `${STATIONS_STATE}/getStationsPriceReportTimeSlots`,
  async () => {
    const { data } = await stationsAPI.getStationsPriceReportTimeSlots();
    return data.slots;
  }
);
